import { useContainer } from '../../useContainer';
import { ClientApi, ToastStateHandler } from '../../../api';
import { isAppError } from '../../../api/utils/ErrorHandler';
import { ClientDto } from '../../../commonTypes/client.types';
import { useTranslation } from '../../useTranslation';

const useHttpArchiveClient = () => {
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (clientId: string, onSuccess?: (client: ClientDto) => void, onError?: () => void) => {
        const { exec: apiExec, abort } = clientApi.archive({
            params: { id: clientId },
            onSuccess: res => {
                toastHandler.push('success', t('clients.archiveTitle'), t('clients.archiveSuccess'));
                onSuccess?.(res.body);
            },
            onError: error => {
                toastHandler.push('error', t('clients.archiveTitle'), isAppError(error) ? error.userMessage : t('clients.archiveError'));
                onError?.();
            },
        });

        apiExec();
        return abort;
    };

    return { exec };
};

export default useHttpArchiveClient;
